export default {
    meetNow: "Meet now",
    meetLater: "Schedule meeting",
    currentEvents: "Nyt",
    upcomingEvents: "Muut tänään"
};



//////////////////
// WEBPACK FOOTER
// ./app/ts/i18n/en.ts
// module id = 227
// module chunks = 0